"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_helmet_1 = require("react-helmet");
const mui_1 = require("tss-react/mui");
const Button_1 = __importDefault(require("@mui/material/Button"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const PiggyBank_png_1 = __importDefault(require("assets/404-Page/PiggyBank.png"));
const ReportProblemLink_1 = __importDefault(require("components/ReportProblemLink"));
const useStyles = (0, mui_1.makeStyles)()(({ palette }) => ({
    root: {
        width: 940,
        margin: 'auto',
        marginTop: 50,
        marginBottom: 50,
        padding: 24,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
    },
    imgPiggyBank: {
        margin: 40,
    },
    txtOops: {
        color: palette.blue2,
        margin: 2,
    },
    link: {
        textDecoration: 'none',
    },
    btnReturn: {
        margin: 20,
    },
}));
const NotFound = () => {
    const { classes } = useStyles();
    return (<>
      <react_helmet_1.Helmet>
        <title>Page Not Found</title>
        <meta name="description" content="Page Not Found"/>
      </react_helmet_1.Helmet>

      <Paper_1.default className={classes.root}>
        <img alt="upside down piggy bank" src={PiggyBank_png_1.default} className={classes.imgPiggyBank}/>
        <Typography_1.default variant="h2" className={classes.txtOops}>
          OOPS!
        </Typography_1.default>
        <Typography_1.default variant="body2">
          Error Code 404
        </Typography_1.default>
        <Typography_1.default variant="h6" m={0.5}>
          We can&apos;t seem to find <br /> the page you&apos;re looking for.
        </Typography_1.default>
        <react_router_dom_1.Link to="/" className={classes.link}>
          <Button_1.default variant="contained" color="primary" className={classes.btnReturn}>
            Return to Dashboard
          </Button_1.default>
        </react_router_dom_1.Link>

        <ReportProblemLink_1.default feedbackSubject="report page not found"/>
      </Paper_1.default>
    </>);
};
exports.default = NotFound;
